<template>
    <div>    
        <div class="row">
            <div class="container container-fluid pesquisa">
                <alert :tipo="'alert-danger'" v-if="this.erroMsg != null">{{this.erroMsg}}</alert>
                <input id='campoTexto' type="text" @input='buscar()' @click='limpaCampo()' v-model="prazoEnvioCampo" class="form-control campoPesquisa" placeholder="Digite o código ou descrição" aria-label="Username" aria-describedby="addon-wrapping"/>
                <button v-if="this.erroMsg != null" class="btn btn-primary botaoVoltar" @click="voltar()">Voltar</button>
            </div>
        </div>
        <div class="row" v-if="this.prazoEnvioFiltro == null">
            <div class="container container-fluid">
                <table class="table table-bordered tabela">
                    <thead>
                        <tr>
                            <th class="tituloTabela" scope="col" colspan="5">Prazos de envio dos Eventos Depois da Implantação do eSocial</th>
                        </tr>
                        <tr class="subtituloTabela">
                            <th scope="col" class="subTituloTabela colCodigo">Código</th>
                            <th scope="col" class="subTituloTabela colNome">Descrição</th>
                            <th scope="col" class="subTituloTabela colDefinicao">Prazo de Envio</th>
                            <th scope="col" class="subTituloTabela colDefinicao">Tipo de Evento</th>
                        </tr>
                    </thead>
                    <tbody>
                       <prazoEnvioAll id="itemlista" v-for="prazoEnvioItem in prazoEnvioLista" :prazoEnvio="prazoEnvioItem" :key="prazoEnvioItem.id"/>
                    </tbody>  
                </table>
            </div>
        </div>
        <div class="row" v-if="this.prazoEnvioFiltro != null">
            <div class="container container-fluid">
                <table class="table table-bordered tabela">
                    <thead>
                        <tr>
                            <th class="tituloTabela" scope="col" colspan="5">Resultado da pesquisa</th>
                        </tr>
                        <tr class="subtituloTabela">
                            <th scope="col" class="subTituloTabela colCodigo">Código</th>
                            <th scope="col" class="subTituloTabela colNome">Descrição</th>
                            <th scope="col" class="subTituloTabela colDefinicao">Prazo de Envio</th>
                            <th scope="col" class="subTituloTabela colDefinicao">Tipo de Evento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <prazoEnvioItem id="itemFiltro" v-for="prazoEnvioItem in prazoEnvioFiltro" :prazoEnvio="prazoEnvioItem" :key="prazoEnvioItem.id"/>
                    </tbody>  
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import alert from '../shared/alert.vue'
import prazoEnvioItem from './prazoEnvioItem.vue'
import prazoEnvioAll from './prazoEnvioAll.vue'
import prazoEnvioService from '../services/prazoEnvioService.js'

export default {
    components:{
        'prazoEnvioItem': prazoEnvioItem,
        'prazoEnvioAll': prazoEnvioAll,
        'alert': alert
    },
    data(){
        return{
            prazoEnvioCampo: null,
            prazoEnvioFiltro: null,
            prazoEnvioLista: null,
            erroMsg: null
        }
    },
    methods:{
        limpaCampo(){
            if(this.erroMsg){
                this.voltar();
            }
        },
        async buscar(){
            if(this.prazoEnvioCampo != null){
                this.erroMsg = null;
                this.prazoEnvioFiltro = await prazoEnvioService.getBusca('BuscaEsocialTabela', {'valor': this.prazoEnvioCampo});
                    if(this.prazoEnvioFiltro == null || this.prazoEnvioFiltro == ''){
                        this.prazoEnvioLista = null
                        this.erroMsg = 'Dado não encontrado'
                    }else{
                        this.erroMsg = null
                    }
            }
        },
        async getAll(){
            this.prazoEnvioLista = await prazoEnvioService.getAll('esocialTabela');
        },
        voltar(){
            this.prazoEnvioFiltro = null;
            this.erroMsg = null;
            this.prazoEnvioCampo = null;
            setTimeout(()=>{
                document.getElementById('campoTexto').focus();
            },500)
            this.getAll();
        },
        erros(){
            if(this.prazoEnvioCampo == null){
                this.erroMsg = 'Campo vazio';
            }
        }
    },
    async created(){
        await this.getAll();
    }
}
</script>
<style scoped>
    .colCodigo{
       padding:.7em;
    }
    .botaoVoltar{
        float:right;
        position:relative;
        top:-40%;
    }
    .colNome{
        width: 19em;
    }
    .tabela{
        position: relative;
        left: 1em;   
    }
    .subTituloTabela{
        font-size: .9em;
        text-align: center;
    }
    .tituloTabela{
        text-align: center;
        font-size: 1.2em;
    }
    .campoPesquisa{
        width: 20rem;
        position: relative;
        margin-right:1em;
        margin-bottom: 2em;
        height: 2.4em;
    }
    .pesquisa{
        margin-top: 3em;
        position: relative;
        left: 1em;
    }
    </style>





// WEBPACK FOOTER //
// src/components/prazoEnvioPesquisa.vue